import { render, staticRenderFns } from "./wholesale.vue?vue&type=template&id=b5eb3a60&scoped=true"
import script from "./wholesale.vue?vue&type=script&lang=js"
export * from "./wholesale.vue?vue&type=script&lang=js"
import style0 from "./wholesale.vue?vue&type=style&index=0&id=b5eb3a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eb3a60",
  null
  
)

export default component.exports